import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as Breakpoints from '@bubble-ui/particle-breakpoints';
import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
import { isLiquorice, isLollipop } from '@bubble-ui/particle-design-versions';
import * as Layers from '@bubble-ui/particle-layers';
import { CONTENT_WIDTH, DESKTOP_ICON_SIZE, EXTRA_PADDINGS, LARGE_CONTENT_WIDTH, SIDEBAR_WIDTH, SIDE_PADDINGS } from './constants';
export var getDesktopContentSize = function getDesktopContentSize(large, isNarrow) {
  return large && !isNarrow ? LARGE_CONTENT_WIDTH : CONTENT_WIDTH;
};

var getDialogHeightWithoutContent = function getDialogHeightWithoutContent(bottomHeight, navBarHeight) {
  return bottomHeight + navBarHeight + EXTRA_PADDINGS;
};

var getOffsetLeft = function getOffsetLeft(rootWidth, hasLeftSidebar, contentSize, leftSidebarWidth) {
  return rootWidth / 2 + (hasLeftSidebar ? -(contentSize + leftSidebarWidth) / 2 : -contentSize / 2);
};

var getOffsetVertical = function getOffsetVertical(rootHeight, contentHeight, dialogHeightWithoutContent) {
  return (rootHeight - (contentHeight + dialogHeightWithoutContent)) / 2;
};

var getIfMobileAndJustTooShort = function getIfMobileAndJustTooShort(rootHeight, rootWidth) {
  return rootHeight > 0 && rootWidth > 0 && rootHeight < Breakpoints.MOBILE_STICKY_MIN_HEIGHT;
};

var safeAreaPaddingConstant = 'constant(safe-area-inset-top) constant(safe-area-inset-right) constant(safe-area-inset-bottom) constant(safe-area-inset-left)';
var safeAreaPaddingEnv = 'env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)';
var safeAreaPadding = global.CSS && typeof global.CSS.supports === 'function' && global.CSS.supports("padding: ".concat(safeAreaPaddingEnv)) ? safeAreaPaddingEnv : global.CSS && typeof global.CSS.supports === 'function' && global.CSS.supports("padding: ".concat(safeAreaPaddingConstant)) ? safeAreaPaddingConstant : undefined;

var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var areButtonsHorizontal = _ref.areButtonsHorizontal,
      backgroundColorToken = _ref.backgroundColorToken,
      designContext = _ref.designContext,
      designVersion = _ref.designVersion,
      hideIntermediatePreRender = _ref.hideIntermediatePreRender,
      isFullScreen = _ref.isFullScreen,
      isMobile = _ref.isMobile,
      isNarrow = _ref.isNarrow,
      isNonStickyIfShortEnough = _ref.isNonStickyIfShortEnough,
      shouldScroll = _ref.shouldScroll,
      hasLeftSidebar = _ref.hasLeftSidebar,
      _ref$leftSidebarWidth = _ref.leftSidebarWidth,
      leftSidebarWidth = _ref$leftSidebarWidth === void 0 ? SIDEBAR_WIDTH : _ref$leftSidebarWidth,
      _ref$rootSize = _ref.rootSize,
      rootHeight = _ref$rootSize.height,
      rootWidth = _ref$rootSize.width,
      contentHeight = _ref.contentSize.height,
      maxHeight = _ref.maxHeight,
      minHeight = _ref.minHeight,
      bottomHeight = _ref.bottomSize.height,
      navBarHeight = _ref.navBarHeight,
      large = _ref.large,
      isContentVerticallyCentered = _ref.isContentVerticallyCentered;
  var cornerRadius = designContext.get('dialog/corner-radius').pixelValue;
  var borderRadius = isLiquorice(designVersion) || isLollipop(designVersion) ? 0 : cornerRadius;
  var backgroundColor = designContext.get(backgroundColorToken, {}).toString();
  return {
    containerStyle: _objectSpread(_objectSpread({
      position: 'relative',
      boxSizing: 'border-box',
      backgroundColor: backgroundColor,
      paddingTop: navBarHeight
    }, isNonStickyIfShortEnough && getIfMobileAndJustTooShort(rootHeight, rootWidth) ? {
      paddingLeft: SIDE_PADDINGS,
      paddingRight: SIDE_PADDINGS
    } : isMobile || isFullScreen ? {
      paddingBottom: bottomHeight,
      paddingLeft: SIDE_PADDINGS,
      paddingRight: SIDE_PADDINGS
    } : {
      paddingBottom: bottomHeight !== 0 ? 30 + bottomHeight : 0,
      paddingLeft: 50,
      paddingRight: 50
    }), hasLeftSidebar ? {
      flexShrink: 'initial',
      width: '100%'
    } : {}),
    rootStyle: {
      backgroundColor: Colors.overlayDesktop(designVersion).toString(),
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      overflow: 'hidden',
      zIndex: 2147483647
    },
    outerWrapperStyle: (isMobile || isFullScreen) && safeAreaPadding ? {
      position: 'absolute',
      visibility: hideIntermediatePreRender && (!rootWidth || !rootHeight) ? 'hidden' : 'visible',
      top: '0',
      bottom: '0',
      right: '0',
      left: '0',
      padding: safeAreaPadding,
      backgroundColor: backgroundColor
    } : {
      position: 'absolute',
      visibility: hideIntermediatePreRender && (!rootWidth || !rootHeight) ? 'hidden' : 'visible',
      top: '0',
      bottom: '0',
      right: '0',
      left: '0'
    },
    innerWrapperStyle: isNonStickyIfShortEnough && getIfMobileAndJustTooShort(rootHeight, rootWidth) ? {
      overflowY: 'scroll',
      overflowX: 'hidden',
      overflowStyle: '-ms-autohiding-scrollbar',
      overflowScrolling: 'touch',
      height: '100%',
      position: 'relative',
      top: 0,
      width: '100%',
      left: 0
    } : {
      width: '100%',
      height: '100%',
      position: 'relative',
      top: 0,
      left: 0
    },
    bottomStyle: _objectSpread(_objectSpread({
      width: '100%',
      zIndex: Layers.DIALOG
    }, isMobile || isFullScreen ? {
      paddingRight: SIDE_PADDINGS,
      paddingLeft: SIDE_PADDINGS,
      paddingTop: 15,
      left: 0
    } : {
      paddingRight: SIDE_PADDINGS,
      paddingLeft: SIDE_PADDINGS,
      paddingTop: 20
    }), isNonStickyIfShortEnough && getIfMobileAndJustTooShort(rootHeight, rootWidth) ? {
      backgroundColor: backgroundColor
    } : !isMobile && !isFullScreen && !shouldScroll ? {
      width: getDesktopContentSize(large, isNarrow),
      left: (hasLeftSidebar ? leftSidebarWidth : 0) + getOffsetLeft(rootWidth, hasLeftSidebar, getDesktopContentSize(large, isNarrow), leftSidebarWidth),
      bottom: getOffsetVertical(rootHeight, contentHeight, getDialogHeightWithoutContent(bottomHeight, navBarHeight)),
      position: 'absolute'
    } : !isMobile && !isFullScreen && shouldScroll ? {
      width: getDesktopContentSize(large, isNarrow),
      left: (hasLeftSidebar ? leftSidebarWidth : 0) + getOffsetLeft(rootWidth, hasLeftSidebar, getDesktopContentSize(large, isNarrow), leftSidebarWidth),
      backgroundColor: backgroundColor,
      position: 'absolute',
      bottom: 0
    } : {
      backgroundColor: backgroundColor,
      bottom: 0,
      position: 'absolute'
    }),
    navBarWrapperStyle: _objectSpread(_objectSpread({
      position: 'absolute'
    }, isMobile || isFullScreen ? {
      width: '100%',
      left: 0,
      top: 0
    } : {
      width: getDesktopContentSize(large, isNarrow),
      left: (hasLeftSidebar ? leftSidebarWidth : 0) + getOffsetLeft(rootWidth, hasLeftSidebar, getDesktopContentSize(large, isNarrow), leftSidebarWidth),
      top: shouldScroll ? 0 : getOffsetVertical(rootHeight, contentHeight, getDialogHeightWithoutContent(bottomHeight, navBarHeight))
    }), {}, {
      zIndex: Layers.DIALOG
    }),
    containerWrapperStyle: _objectSpread({
      borderRadius: borderRadius,
      backgroundColor: backgroundColor
    }, isMobile || isFullScreen ? _objectSpread({
      width: '100%',
      height: '100%'
    }, isContentVerticallyCentered ? {
      justifyContent: 'center'
    } : {}) : _objectSpread(_objectSpread({}, shouldScroll ? {} : {
      overflow: 'hidden'
    }), {}, {
      boxShadow: "0px 3px 15px 6px ".concat(Colors.__shadowMedium(designVersion).toString()),
      position: 'absolute',
      left: getOffsetLeft(rootWidth, hasLeftSidebar, getDesktopContentSize(large, isNarrow), leftSidebarWidth),
      top: shouldScroll ? 0 : getOffsetVertical(rootHeight, contentHeight, getDialogHeightWithoutContent(bottomHeight, navBarHeight)),
      width: getDesktopContentSize(large, isNarrow) + (hasLeftSidebar ? leftSidebarWidth : 0)
    })),
    containerWrapperColumnsStyle: {
      flexDirection: 'row'
    },
    contentStyle: _objectSpread(_objectSpread({}, maxHeight && !isMobile && !isFullScreen && {
      maxHeight: "calc(".concat(maxHeight, " - ").concat(getDialogHeightWithoutContent(bottomHeight, navBarHeight), "px)"),
      overflowX: 'none',
      overflowY: 'auto'
    }), minHeight && minHeight < rootHeight && !isMobile && !isFullScreen ? _objectSpread({
      minHeight: minHeight - getDialogHeightWithoutContent(bottomHeight, navBarHeight)
    }, isContentVerticallyCentered ? {
      justifyContent: 'center'
    } : {}) : {}),
    sidebarWrapperStyle: {
      width: leftSidebarWidth
    },
    scrollableAreaStyle: isNonStickyIfShortEnough && getIfMobileAndJustTooShort(rootHeight, rootWidth) ? {
      display: 'table'
    } : {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      overflowY: shouldScroll ? 'scroll' : 'hidden',
      overflowX: 'hidden',
      overflowStyle: '-ms-autohiding-scrollbar',
      overflowScrolling: 'touch'
    },
    dialogIconContainer: _objectSpread({
      position: 'absolute',
      top: getOffsetVertical(rootHeight, contentHeight, getDialogHeightWithoutContent(bottomHeight, navBarHeight)) - DESKTOP_ICON_SIZE / 2,
      left: 0,
      right: 0,
      width: '100%',
      alignItems: 'center',
      display: 'flex',
      zIndex: 1
    }, hasLeftSidebar ? {
      paddingLeft: leftSidebarWidth
    } : {}),
    dialogIconInlineContainer: {
      width: '100%',
      alignItems: 'center',
      display: 'flex',
      paddingBottom: 30
    },
    backgroundClickHandlerStyle: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    footerButtonsWrapperStyle: {
      flexDirection: areButtonsHorizontal ? 'row' : 'column'
    },
    buttonWrapperStyle: function buttonWrapperStyle(isLast) {
      return {
        flexShrink: 1,
        marginRight: areButtonsHorizontal && !isLast ? 10 : 0,
        marginBottom: isLast ? isNarrow ? 15 : 20 : isMobile || isFullScreen ? isNarrow ? 10 : 15 : isNarrow ? 5 : 10,
        width: '100%'
      };
    }
  };
};

export default getDefaultStyleSheet;
//# sourceMappingURL=getDefaultStyleSheet.js.map